export function getValueFromLocalizedResponse(response: any, key: string, locale?: string): string {
  if (locale) {
    const component = response?.data
      ?.at(0)
      ?.componentsGroups.at(0)
      ?.components?.find((item: any) => item?.key === key);
    if (component?.localizations?.filter((d: any) => d.language?.toLowerCase() === locale?.toLowerCase()).length > 0)
      return component?.localizations?.find((d: any) => d.language?.toLowerCase() === locale?.toLowerCase()).value;

    return component?.localizations.at(0)?.value;
  }
  return response?.data
    ?.at(0)
    ?.componentsGroups.at(0)
    ?.components?.find((item: any) => item?.key === key)
    ?.localizations?.at(0)?.value;
}

export function getLocalizedValue(
  localizations: UILocalizationViewDto[],
  lang: string,
  specific: boolean = false
): string | undefined {
  if (specific) return localizations?.find((l) => l.language?.toLowerCase() === lang.toLowerCase())?.value;

  return (
    localizations?.find((l) => l.language?.toLowerCase() === lang.toLowerCase())?.value || localizations?.at(0)?.value
  );
}

export function getUrlParams(param: { [key: string]: string | string[] | undefined }) {
  const urlSearchParams = new URLSearchParams();

  Object.entries(param).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val) => urlSearchParams.append(key, val));
    } else if (value !== undefined) {
      urlSearchParams.append(key, value);
    }
  });

  return urlSearchParams;
}

export function checkAndSetBenefitCard(
  benefit: any,
  index: number,
  arrayToSet: { title: string; desc: string }[],
  lang: string
) {
  let t = arrayToSet[index - 1];
  if (benefit?.key === `benefitsCard${index}Title`) {
    t = { ...t, title: getLocalizedValue(benefit?.localizations, lang) ?? '' };
    arrayToSet[index - 1] = t;
  }
  if (benefit?.key === `benefitsCard${index}Description`) {
    t = { ...t, desc: getLocalizedValue(benefit?.localizations, lang) ?? '' };
    arrayToSet[index - 1] = t;
  }
  return t;
}

export function setBenefitsArray(
  benefits: any,
  benefitsCount: number,
  benefitsArray: { title: string; desc: string }[],
  lang: string
) {
  if (benefits && benefits.data && benefits.data.length > 0) {
    for (let index = 0; index < benefits.data[0].componentsGroups[0]?.components?.length; index++) {
      if (!benefits.data[0].componentsGroups[0]?.components[index].key.includes('benefitsCard')) continue;

      const benefit = benefits.data[0].componentsGroups[0]?.components[index];

      for (let i = 1; i <= benefitsCount; i++) checkAndSetBenefitCard(benefit, i, benefitsArray, lang);
    }
  }
}

export const excludeRobots = ['searchText', 'pageIndex', 'srsltid', 'searchtext', 'pageindex'];

export function getShortCondition(condition?: string): string {
  return (condition?.indexOf('(') !== -1 ? condition?.substring(0, condition?.indexOf('(')) : condition) ?? '';
}
